import apiClient from './client';

export interface Backup {
  filename: string;
  date: string;
  size: number;
  size_formatted: string;
  download_url: string;
}

export interface BackupsResponse {
  success: boolean;
  data?: {
    backups: Backup[];
    hostname: string;
    last_backup: string | null;
  };
  error?: string;
  message?: string;
}

export async function getBackups(subscriptionId: string): Promise<BackupsResponse> {
  const response = await apiClient.get<BackupsResponse>(
    `/api/v1/subscriptions/${subscriptionId}/backups`
  );
  return response.data;
}
